import { z } from 'zod';
import { ID, Url } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { connectorSchema } from '../models/connector.schema';
import { connectorListQuerySchema } from './list.schema';

export type ConnectorListQuery = Partial<{
  id: ID | ID[];
  name: string;
  serviceUrl: Url;
}> &
  PaginationQuery;

export const list = (query: ConnectorListQuery = {}) => {
  return {
    endpoint: `/connectors`,
    method: 'GET',
    responseSchema: listResponse(connectorSchema),
    query: { ...query, includeTotal: true },
    querySchema: connectorListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
